'use client'

import "./LoaderPage.scss";
import { motion, AnimatePresence } from "framer-motion";
import { useEffect, useState } from "react";
import AnimatedSVG from "@/shared/ui/LoaderPage/ui/AnimationSVG.jsx";
import { useAboutSettingQuery } from '@/shared/api-rtk/index.js';
import { TOAST_ERROR } from '@/shared/constants/toastTypes.js'

export const LoaderPage = ({ loading }) => {
  const { data: settingData, error, isLoading } = useAboutSettingQuery(4);
  const [isVisible, setIsVisible] = useState(loading);

  const [closeSite, setCloseSite] = useState(false)

  useEffect(() => {
    if (!settingData) return
    const res = settingData

    if (res.result === 'success') {
      setCloseSite(Number(res.data.value) === 1)
    } else {
      TOAST_ERROR('Произошла ошибка back-end, обратитесь к разработчику сайта.')
    }
  }, [settingData])


  useEffect(() => {
    if (isLoading) return
    if (!loading) {
      const timer = setTimeout(() => setIsVisible(false), 100); // Даем 0.5 секунды перед исчезновением
      return () => clearTimeout(timer);
    } else {
      setIsVisible(true); // Показываем снова, если загрузка начинается заново
    }
  }, [loading, isLoading]);

  return (
      <AnimatePresence>
      {(isVisible || closeSite) && (
        <motion.div
          className="LoaderPage"
          initial={{ opacity: 1 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.4, ease: "easeInOut" }}
        >
          <div className="containerLoader">
            {closeSite && <p>Ведутся технические работы, попробуйте обновить через несколько минут.</p>}
            <AnimatedSVG />
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};